import { Entity } from '../entity.js';
import { clampGroundCast, isInAbilityCircle, isWithinAbilityRange } from '../combat/abilityArea.js';

export function createBrand(id = 'brand-1', team = 'blue', x = 300, y = 1300) {
  return new Entity({
    id,
    type: 'champion',
    team,
    x,
    y,
    maxHp: 535,
    maxMp: 470,
    ad: 60,
    ap: 0,
    armor: 24,
    mr: 30,
    ms: 340,
    attackRange: 550,
    attackSpeed: 0.625,
    name: 'Brand',
    radius: 20
  });
}

export function castBrandQ(caster, targetX, targetY, projectiles, gameTime) {
  if (!caster || caster.isDead || caster.mp < 70) return false;
  caster.mp -= 70;
  const angle = Math.atan2(targetY - caster.y, targetX - caster.x);
  const damage = 72 + (caster.ap || 0) * 0.65;
  projectiles.push({
    id: `brand-q-${caster.id}-${gameTime}`,
    casterId: caster.id,
    team: caster.team,
    x: caster.x,
    y: caster.y,
    vx: Math.cos(angle) * 1600,
    vy: Math.sin(angle) * 1600,
    range: 1100,
    traveled: 0,
    damage,
    damageType: 'magic',
    radius: 60
  });
  return true;
}

export function castBrandW(caster, x, y, entities = []) {
  if (!caster || caster.isDead || caster.mp < 60) return false;
  caster.mp -= 60;
  const aim = clampGroundCast(caster, x, y, 900);
  const damage = 68 + (caster.ap || 0) * 0.6;
  for (const e of entities) {
    if (!e || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, aim.x, aim.y, 260, caster)) continue;
    e.takeDamage(damage, caster, 'magic');
  }
  return true;
}

export function castBrandE(caster, target, entities = []) {
  if (!caster || caster.isDead || !target || target.isDead) return false;
  if (caster.mp < 90) return false;
  if (!isWithinAbilityRange(caster, target, 675, caster)) return false;
  caster.mp -= 90;
  const damage = 70 + (caster.ap || 0) * 0.55;
  target.takeDamage(damage, caster, 'magic');
  for (const e of entities) {
    if (!e || e === target || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, target.x, target.y, 300, caster)) continue;
    e.takeDamage(damage * 0.75, caster, 'magic');
  }
  return true;
}

export function castBrandR(caster, target, entities = []) {
  if (!caster || caster.isDead || !target || target.isDead) return false;
  if (caster.mp < 100) return false;
  if (!isWithinAbilityRange(caster, target, 750, caster)) return false;
  caster.mp -= 100;
  const damage = 100 + (caster.ap || 0) * 0.5;
  target.takeDamage(damage, caster, 'magic');
  let bounced = 0;
  for (const e of entities) {
    if (!e || e === target || e.isDead || e.team === caster.team) continue;
    if (!isInAbilityCircle(e, target.x, target.y, 600, caster)) continue;
    e.takeDamage(damage * 0.85, caster, 'magic');
    bounced += 1;
    if (bounced >= 2) break;
  }
  return true;
}
